import React from 'react';
import { Button } from './ui/Button';
export function CTASection() {
  return <section className="py-12 bg-main border-t border-[#D9D0C1]" data-id="element-41">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-42">
        <h2 className="text-3xl md:text-5xl font-serif text-title mb-6 leading-tight" data-id="element-43">
          Tu privacidad no se negocia. <br data-id="element-44" />
          Tus ingresos tampoco.
        </h2>
        <p className="text-lg text-body mb-10 max-w-2xl mx-auto" data-id="element-45">
          Si hoy no publicas no es falta de capacidad. Es falta de método.
          Empieza con una cuenta que no tiene tu cara, pero sí tiene dirección.
        </p>
        <Button size="lg" withArrow className="px-12" data-id="element-46">
          Acceder al pack
        </Button>
        <p className="text-xs text-body mt-3" data-id="element-47">
          Privacidad primero · Acceso inmediato · Garantía 14 días
        </p>
      </div>
    </section>;
}